/* eslint-disable no-undef */

import domready from 'domready';
import client from './render-recommendations';
import "./style.css";

domready(() => {
    client(window).catch(err => new Error(err));
});
